<div mat-dialog-title>
  <span>{{ "chatDialog.title" | translate }} {{ userDataEmail }}</span>

  <span>
    <button mat-icon-button (click)="startCall()" *ngIf="!onCall">
      <mat-icon>phone</mat-icon>
    </button>
    <button mat-icon-button (click)="startCall()" *ngIf="!onCall">
      <mat-icon>camera</mat-icon>
    </button>
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>clear</mat-icon>
    </button>
  </span>
</div>

<mat-dialog-content>
  <div class="messages-container" *ngIf="isChatOpen()">
    <ng-container *ngFor="let message of messages">
      <div
        class="message"
        [ngClass]="{
          'message-sent': message.sender,
          'message-received': !message.sender
        }"
      >
        <div class="text">{{ message.text }}</div>
        <div class="timestamp">{{ message.timestamp }}</div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="calling" class="calling-overlay">
    <div class="calling-message">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Calling...</span>
    </div>
  </div>
  <div *ngIf="callDeclined" class="call-declined-overlay">
    <div class="call-declined-message">
      <mat-icon color="warn" fontIcon="call_end" class="declined-icon"
        >call_end</mat-icon
      >
      <span>Call Declined</span>
    </div>
  </div>
  <div *ngIf="isVideoCallOpen()" class="video-call-container">
    <div class="video-wrapper">
      <video #remoteVideo autoplay playsinline class="remote-video"></video>
      <video #localVideo autoplay muted playsinline class="local-video"></video>
      <button
        mat-fab
        color="warn"
        class="hangup-btn"
        (click)="callEndedFunction()"
      >
        <mat-icon>call_end</mat-icon>
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="message-input" *ngIf="isChatOpen()">
    <textarea matInput [(ngModel)]="message"></textarea>
    <button mat-raised-button color="primary" (click)="sendMessage()">
      {{ "chatDialog.sendButton" | translate }}
    </button>
  </div>
</mat-dialog-actions>
